module.exports = __webpack_public_path__ + "static/media/avatar01@2x.7813c7b3.png";